// extracted by mini-css-extract-plugin
export var addWidgetButton = "_s-6";
export var backButton = "_s-1";
export var pageContainer = "_s-2";
export var settingsContent = "_s-0";
export var widgetContainer = "_s-5";
export var widgetSubsectionItem = "_s-3";
export var widgetSubsectionItemContent = "_s-4";